import { AuthEventCore, AuthEventBusEmiter  } from './eventBus'
import getAuthStoreModule from './store.js'
import { AuthCore } from './authCore'



export const AuthModule = {
  config(Vue, { store, auth}) {
    let authEventBus = new Vue()
    Vue.$authEventBus = new AuthEventCore(authEventBus)
    Vue.$authEventEmiter = new AuthEventBusEmiter(authEventBus)

    let authStoreModule = getAuthStoreModule(Vue)

    // определяем роль пользователя для анонимных пользователей, если такие разрешены
    let appModel =  store.getters.appModel
    if (appModel.NeedAuthentication && appModel.AllowAnonimousUsers) {
      authStoreModule.state.user.role = appModel.AnonimousUserRole
    } 

    store.registerModule('auth', authStoreModule)
    Vue.$authCore = Vue.prototype.$authCore = new AuthCore(store, auth)
  }
}

